import Vue from 'vue';
import { apolloClient } from '@/plugins/vue-apollo';
import gql from 'graphql-tag';

// eslint-disable-next-line
export const fetchAttributeByItem = gql`
  query GetCategoryAttributes(
      $category: uuid!
    ) {
    taxonomy_attribute(
      where: {
        category_id: {_eq: $category}
      },
        order_by: {mdm_order: asc}
      ) {
      id
      mdm_code
      mdm_name
      mdm_order
      is_required
    }
  }
`;


const attribute = {
  namespaced: true,
  state: {
    item_attributes: [],
  },
  actions: {
    async initial({ commit }) {
      commit('SET_ITEM_ATTRIBUTES', []);
    },
    async get({ commit, state }, category) {
      try {
        const requestQuery = {
          query: fetchAttributeByItem,
          variables: {
            category: `${category}`,
          },
        };

        const result = await apolloClient.query(requestQuery);
        if (result && result.data) {
          commit('SET_ITEM_ATTRIBUTES', result.data);
        }
      } catch (err) {
        window.console.error(err);
      }
      return state.item_attributes;
    },
  },
  mutations: {
    SET_ITEM_ATTRIBUTES(state, data) {
      Vue.set(state, 'item_attributes', data.taxonomy_attribute);
    },
  },
  getters: {
    itemAttributesInfo: state => state.item_attributes,
  },
};

export default attribute;



// WEBPACK FOOTER //
// ./src/store/modules/core/attribute.js